import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { Button } from '@calendly/ui/components/button'

import { useI18n } from 'locales'

const ErrorAlert = ({
  error,
  dismissError,
  title,
  text,
  buttonText,
  buttonClick
}) => {
  const { i18n } = useI18n()
  const alertTitle = title || i18n.t('errors.default_no_action')
  const alertText = text || error.message
  const alertButtonText = buttonText || i18n.t('errors.messages.try_again')
  const alertButtonClick = buttonClick || dismissError

  return (
    <Popup
      isOpen={Boolean(error)}
      isBlocking
      onClose={dismissError}
      title={alertTitle}
    >
      <Body>{alertText}</Body>
      <Footer>
        <Button onClick={alertButtonClick}>{alertButtonText}</Button>
      </Footer>
    </Popup>
  )
}

export default ErrorAlert
